<template>
  <div class="d-flex flex-column">
    <GmapMap
      :center="{ lat: lat, lng: lng }"
      :zoom="15"
      class="map"
      :options="{
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: true,
        fullscreenControl: true,
        disableDefaultUi: true,
      }"
    >
      <GmapMarker
        :position="{
          lat: lat,
          lng: lng,
        }"
      />
    </GmapMap>
  </div>
</template>

<script>
export default {
  props: {
    lat: {
      type: Number,
      default: 0,
    },
    lng: {
      type: Number,
      default: 0,
    }
  },
}
</script>

<style scoped>
.map {
  border-radius: 15px !important;
  height: 30vh;
  width: 100%;
}

::v-deep .gmap-auto {
  width: 100%;
  line-height: 35px;
  border: 1px solid #e8e9e9;
  border-radius: 5px;
  font-size: 14px;
  background: #ffffff !important;
}

.gmap-auto:focus {
  outline: none !important;
}

</style>